export const loadExternalScript = (src: string, id: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    console.log(`[LoadExternalScript] Loading script: ${src}`);
    if (document.getElementById(id)) {
      console.log(`[LoadExternalScript] Script with id ${id} already exists.`);
      resolve();
      return;
    }
    console.log(`[LoadExternalScript] Creating script element for: ${src}`);

    const script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.async = true;
    script.crossOrigin = 'anonymous';

    script.onload = () => {
      if (id === 'apple-pay-script')
        console.log(`[ApplePay] Script loaded successfully: ${src}`);
      resolve();
    };
    script.onerror = () => reject(new Error(`Failed to load: ${src}`));

    document.body.appendChild(script);
  });
};
